import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecf76ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offers" }
const _hoisted_2 = { class: "mt-15" }
const _hoisted_3 = { class: "flex flex-row flex-nowrap items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCollage = _resolveComponent("ProductCollage")!
  const _component_StoreName = _resolveComponent("StoreName")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (offer) => {
      return (_openBlock(), _createElementBlock("article", {
        key: offer.id,
        class: "offer"
      }, [
        _createVNode(_component_ProductCollage, {
          variants: offer.skus
        }, null, 8, ["variants"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.itemTitle, [_ctx.formatDate(offer.created)])), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.itemCount, [offer.skus.length])), 1),
          _createElementVNode("p", null, [
            _createVNode(_component_StoreName, {
              id: offer.storeId,
              label: _ctx.labels.itemStoreName
            }, null, 8, ["id", "label"])
          ]),
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: _ctx.getDetailsLocation(offer.id),
              title: _ctx.labels.itemLinkText,
              class: "c-magic-line relative z-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.labels.itemLinkText), 1)
              ]),
              _: 2
            }, 1032, ["to", "title"]),
            _createVNode(_component_c_icon, {
              name: "icon-arrow-small",
              class: "h-8 ml-3 mt-1 xl:h-10 xl:ml-5 xl:mt-0"
            })
          ])
        ]),
        _createVNode(_component_router_link, {
          to: _ctx.getDetailsLocation(offer.id),
          title: _ctx.labels.itemLinkText,
          class: "offer__link"
        }, null, 8, ["to", "title"])
      ]))
    }), 128))
  ]))
}